import {
  AddCircleOutline,
  ArrowRightAlt,
  CalendarMonth,
  FolderCopyRounded,
  FolderRounded,
  FormatListBulleted,
  HdrPlus,
  PlusOne,
  Window,
} from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import DecalarationLoader from "./Loader/DecalarationLoader";
import { Link } from "react-router-dom";
import { ApiUrl, FileLinkAssets } from "../config";


const MesDeclarations = () => {
  const [loading, setLoading] = useState(true);
  const [Declarations, setDeclarations] = useState([]);
  const token = Cookies.get("access_token");

  
  const GetDeclarationsByPatientId = async (page) => {
    
    if (token) {
      const decodedToken = jwtDecode(token);
      const citoyen_id = decodedToken.citoyen_id;
      try {
        setLoading(true);
        const response = await fetch(
          `${ApiUrl}get-declarations-by-patient-id?citoyen_id=${citoyen_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setDeclarations(data.declarations);
          setLoading(false);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
          setLoading(false);
      }
    }
  };

  const getProgressBarStyle = (progress) => {
    if (progress === 100) {
      return { background: "rgba(0,201,167, 1)", width: "100%" }; // Completed
    } else if (progress <= 30) {
      return { background: "red", width: `${progress}%` }; // Danger
    } else if (progress <= 50) {
      return { background: "rgb(255, 193, 7)", width: `${progress}%` };
    } else if (progress > 50) {
      return {background: "rgb(0,201,167)", width: `${progress}%` }; // Success
    } else {
      return { background: "gray", width: `${progress}%` }; 
    }
  };

  useEffect(() => {
    GetDeclarationsByPatientId(); // Fetch citoyen data when component mounts
  }, [token]);



  
  return (
    <div>
      <div className="row align-items-center mb-2">
        <div className="d-flex justify-content-between mb-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb breadcrumb-no-gutter">
              <li class="breadcrumb-item">
                <a class="breadcrumb-link" href="javascript:;">
                  Page d'acceuil
                </a>
              </li>
              <li
                class="breadcrumb-item active"
                style={{ color: "rgb(255, 77, 7)" }}
                aria-current="page"
              >
                Dossiers
              </li>
            </ol>
          </nav>
      
        </div>

        <div className="col">
          <h2 className="h4 mb-3 text-dark">
            {" "}
            <FolderRounded className="mb-2" /> Mes Dossiers
          </h2>
        </div>
        <div className="col-auto">
        <Link to={`/mon-espace/nouvelle-declaration`} className="custom-btn btn-base me-3 fw-bold">
            <AddCircleOutline /> Nouvelle déclaration
          </Link>
          <ul className="nav nav-segment " id="connectionsTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="nav-link active"
                id="grid-tab"
                data-bs-toggle="tab"
                href="#grid"
                role="tab"
                aria-controls="grid"
                aria-selected="true"
                title="Column view"
              >
                <Window />
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="nav-link"
                id="list-tab"
                data-bs-toggle="tab"
                href="#list"
                role="tab"
                aria-controls="list"
                aria-selected="false"
                title="List view"
                tabindex="-1"
              >
                <FormatListBulleted />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div
        className="row"
        data-aos="fade-bottom"
        data-aos-delay="100"
        data-aos-duration="900"
      >
      {loading
        ? Array(6)
            .fill(0)
            .map((_, index) => <DecalarationLoader key={index} />)
        : Declarations && Declarations.length > 0
        ? Declarations.map((dec, index) => (
            <div className=" col-lg-4 col-md-6  mb-3 mb-lg-5">
              <div className="card h-100">
                <div class="card-header">
                  <div className="pe-2 d-flex align-items-start">
                    <div className="d-flex align-items-start">
                      <div>
                        <img
                         src={`/assets/img/hna-meak/FOLDER - Copie.png`}
                          alt="profile"
                          class="avatar avatar-xs avatar-rounded rounded-circle mb-3 ng-star-inserted"
                        />
                      </div>
                      <div className="me-2 ms-2">
                        <h5 className="mb-1">ID: {index +1}</h5>
                        <div className="client-info d-flex align-items-center">
                          <h6 className="mb-0 me-1">Responsable :</h6>
                          <span class="text-blue">{dec.emp_resp?.employe?.nom} {dec.emp_resp?.employe?.prenom}</span>
                        </div>
                      </div>
                    </div>
                    <div class="ms-auto">
                    <Link
                         to={`/mon-espace/detail-dossier/${dec.uid}`}
                        className="custom-btn custom-btn-warning-outline btn-sm ms-auto fw-bolder text-center align-items-center test"
                      >
                        Voir Plus
                        <ArrowRightAlt />
                      </Link>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <div class="d-flex align-items-center flex-wrap">
                    <div class="p-2 rounded me-auto mb-3">
                      <h6 class="mb-1">
                        <i class="mdi mdi-home"></i> Centre :
                        <span class="text-body fw-normal"><span class="text-body fw-normal">{dec.emp_resp?.employe?.centre?.name?.replace(/centre/gi, '')}</span>                        </span>
                      </h6>
                      <h6 class="mb-1">
                        <i class="mdi mdi-map-marker"></i> Ville :
                        <span class="text-body fw-normal">{dec.emp_resp?.employe?.centre?.ville}</span>
                      </h6>
                    </div>
                    <div class="text-end mb-3">
                      <h6 class="mb-1">
                        <CalendarMonth
                          className="mb-1"
                          style={{ fontSize: "18px" }}
                        />
                        Agression:
                        <span class="text-body fw-normal ms-4">{dec.date_aggression}</span>
                      </h6>
                      <h6 class="mb-1">
                        <CalendarMonth
                          className="mb-1"
                          style={{ fontSize: "18px" }}
                        />
                        Signalement:
                        <span class="text-body fw-normal ms-2">{dec.date_signalement}</span>
                      </h6>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <small>Progrès: 3/3</small>
                    <small>{dec.progress}% Completed</small>
                  </div>
                  <div class="progress mb-3" style={{ height: "8px" }}>
                    <div
                      class="progress-bar"
                      style={getProgressBarStyle(dec.progress)}
                      role="progressbar"
                      aria-valuenow={dec.progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          ))
          : (
              
            <div
            class="col-12 d-flex justify-content-center align-items-center flex-column"
          >
            <div class="mt-md-3 mt-xl-0 text-muted">
              <div class="icon-container">
                <img
                  src="/assets/illustration/Empty state icon..svg"
                  class="pending-icon"
                  alt="Icone de rendez-vous en attente"
                />
              </div>
              <p class="text-muted text-center">
                Aucune décalartion trouvée !
              </p>
            </div>
          </div>
            )}
      </div>
    </div>
  );
};

export default MesDeclarations;
